/* eslint-disable no-restricted-syntax */
/* eslint-disable guard-for-in */
import { defineStore } from 'pinia';

import {
  AutocompleteRepository,
  IssuerResponse,
} from '@/repositories/generated';

type IssuerAutocompleteStoreState = {
  issuers: IssuerResponse[];
  tenantId: string | undefined;
};

export const useIssuerAutocompleteStore = defineStore('issuerAutocomplete', {
  state: (): IssuerAutocompleteStoreState => ({
    issuers: [],
    tenantId: undefined,
  }),
  actions: {
    async getIssuers(tenantId?: string) {
      // 一度取得したらキャッシュから取得
      // if (this.issuers.length && this.tenantId === tenantId) {
      //   return this.issuers;
      // }

      const res = await AutocompleteRepository.searchIssuer({
        term: undefined,
        tenantId,
      });
      this.issuers = res;
      return res;
    },
  },
});
